"use strict";

module.exports = function (accumulator, order, product, component) {
  return accumulator + "".concat(component.has_variable_data ? '-VariableData' : '');
};